import { createSlice, current, PayloadAction } from "@reduxjs/toolkit";
import { ToastNotification } from "../../types/errors";

export interface ToastNotifications {
  notifications: ToastNotification[];
}

const initialState: ToastNotifications = {
  notifications: [],
};

const toastNotificationsSlice = createSlice({
  name: "toastNotifications",
  initialState,
  reducers: {
    setNotification: (state, action: PayloadAction<ToastNotification>) => {
      state.notifications.push(action.payload);
    },
    removeNotification: (state, action: PayloadAction<number>) => {
      state.notifications.splice(action.payload, 1);
    },
  },
});

export const { setNotification, removeNotification } =
  toastNotificationsSlice.actions;

export default toastNotificationsSlice.reducer;
